import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/welcome.png'


const _hoisted_1 = { class: "trezo-card bg-primary-500 mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content relative ltr:md:pr-[230px] rtl:md:pl-[230px]" }
const _hoisted_3 = { class: "md:pt-[5px] md:pb-[5px]" }
const _hoisted_4 = { class: "mb-[5px] md:mb-[2px] font-semibold text-white" }
const _hoisted_5 = { class: "text-[#ffcea9]" }
const _hoisted_6 = { class: "text-[#d5d9e2]" }
const _hoisted_7 = { class: "sm:flex items-center" }
const _hoisted_8 = { class: "flex items-center ltr:sm:mr-[20px] ltr:2xl:mr-[40px] rtl:sm:ml-[20px] rtl:2xl:ml-[40px]" }
const _hoisted_9 = { class: "text-[15px] md:text-md text-white block font-semibold mb-[1px] md:mb-0" }
const _hoisted_10 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_11 = { class: "block text-gray-200" }
const _hoisted_12 = { class: "flex items-center mt-[15px] sm:mt-0" }
const _hoisted_13 = { class: "text-[15px] md:text-md text-white block font-semibold mb-[1px] md:mb-0" }
const _hoisted_14 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_15 = { class: "block text-gray-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.directT('dashboard.welcome')) + ", ", 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.userName) + "!", 1)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.directT('dashboard.whatsHappening')), 1),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "border-t border-primary-400 mt-[15px] mb-[15px] md:mt-[30px] md:mb-[33px]" }, null, -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-[42px] h-[42px] rtl:ml-[12px] ltr:mr-[12px] bg-primary-50 text-primary-500 rounded-md flex items-center justify-center" }, [
              _createElementVNode("i", { class: "material-symbols-outlined" }, " shopping_bag ")
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_9, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "..."))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.todayOrdersCount) + " " + _toDisplayString(_ctx.directT('dashboard.newOrders')), 1)
                    ], 64))
              ]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.directT('dashboard.awaitingProcessing')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-[42px] h-[42px] rtl:ml-[12px] ltr:mr-[12px] bg-danger-50 text-danger-500 rounded-md flex items-center justify-center" }, [
              _createElementVNode("i", { class: "material-symbols-outlined" }, " chat_error ")
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_13, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "..."))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.lowStockCount) + " " + _toDisplayString(_ctx.directT('dashboard.products')), 1)
                    ], 64))
              ]),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.directT('dashboard.outOfStock')), 1)
            ])
          ])
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-center md:absolute ltr:right-0 rtl:left-0 md:max-w-[208.04px] md:top-1/2 md:-translate-y-1/2 mt-[20px] md:mt-0" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "inline-block",
          alt: "welcome-image"
        })
      ], -1))
    ])
  ]))
}